export const setBooking = booking => ({
    type: "SET_BOOKING",
    payload: booking
})

export const setCurrency = currency => ({
    type: "SET_CURRENCY",
    payload: currency
})